import { type MarkType } from "prosemirror-model";
import { type EditorState } from "prosemirror-state";

export function markActive(state: EditorState, type: MarkType) {
	const { from, $from, to, empty } = state.selection;
	if (empty) {
		return !!type.isInSet(state.storedMarks || $from.marks());
	} else {
		return state.doc.rangeHasMark(from, to, type);
	}
}
